export default {
  namespaced: true,
  state: {
    path: "abco/groups",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      options["branch"] = rootState.ABCO.branch._id;
      options["academicYear"] = rootState.ABCO.academicYear.year;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${Object.entries(options)
            .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
            .join("&")}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    list({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list/?branch=${rootState.ABCO.branch._id}&academicYear=${rootState.ABCO.academicYear.year}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    last({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/last/?branch=${rootState.ABCO.branch._id}&academicYear=${rootState.ABCO.academicYear.year}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    add({ dispatch, state, rootState }, data) {
      data["branch"] = rootState.ABCO.branch._id;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
